<template>
  <v-selectmenu 
    :data="filter.options"
    :multiple="filter.multiple"
    :query="false"
    :width="250"
    :scroll="false"
    :title="filter.title" 
    key-field="id"
    v-model="selected">
    <a class="btn btn-white no-margin">
      <slot name="button"></slot>
    </a>
    <template #row="{ row }">
      <span>
        {{ row.label }}
      </span>
    </template>
  </v-selectmenu>
</template>

<script>

export default { 
  name: 'DropdownFilter',
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: [Array, Number, String]
    }
  },
  computed: {
    selected: {
      get() {
        if (this.value instanceof Array) {
          return this.value.join(',')
        }
        return this.value
      },
      set(val) {
        if (val && this.filter.multiple) {
          val = val.split(',')
        }
        this.$emit('set-filter', {
          id: this.filter.id,
          values: val && val != 0 ? val : null
        })
      }
    }
  }
}
</script>
